import Component from './I18nOptions';
import I18nService from '../../../services/I18nService';

import { connect } from 'react-redux';

// on map le state de redux sur les props du composant
const mapStateToProps = (state, props) => {
  // const {globalKey,flow} = state.app;


  // i18n service
  const myI18nService = I18nService.getInstance();

  let i18nOptions = [];
  props.options.forEach((option) => {
    const i18nOption = {
      ...option,
      hasLabel: myI18nService.exists(option.labelKey),
      label: myI18nService.t(option.labelKey)
    };
    i18nOptions.push(i18nOption);
  });

  return {
    i18nOptions
  };
};

export default connect(mapStateToProps, undefined)(Component);
